module.exports = __webpack_public_path__ + "img/34.ad34b0c7.png";